import { render, staticRenderFns } from "./ChangeDetectionReport.vue?vue&type=template&id=316a74d4"
import script from "./ChangeDetectionReport.vue?vue&type=script&lang=js"
export * from "./ChangeDetectionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports